module.exports = __webpack_public_path__ + "static/media/25-WaterHeatExchanger - Water cool - El heat.966024bc.png";